import React from "react";
import {
    Box
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { styled } from "@mui/system";


const StepIconRoot = styled("div")(({ ownerState }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    "& .step-number": {
        width: 50, // Aumenta o tamanho do círculo
        height: 50, // Aumenta o tamanho do círculo
        borderRadius: "50%",
        border: "2px solid " + (ownerState.completed ? "#8D9297" : "#1976d2"),
        color: "#1976d2",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "1rem"
    },
    "& .check-icon": {
        position: "absolute",
        zIndex: 1,
        top: -12, // Ajusta a posição do ícone de check para tocar o círculo
        right: -12, // Ajusta a posição do ícone de check para tocar o círculo
        color: "white",
        backgroundColor: "green",
        borderRadius: "50%",
        padding: 3,
        ...(!ownerState.completed
            ? {
                display: "none",
            }
            : {}),
    },
}));

const StepIcon = (props) => {
    const { active, completed, icon } = props;
    return (
        <StepIconRoot ownerState={{ completed, active }}>
            <div className="step-number">{icon}</div>
            {completed && (
                <Box
                    className="check-icon"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CheckIcon />
                </Box>
            )}
        </StepIconRoot>
    );
};

export default StepIcon;